'use strict';

export default class HCluster {
    static FlattenCluster(c, values = []) {
        if (c.value) {
            values.push(c.value);
        }
        else {
            HCluster.FlattenCluster(c.left, values);
            HCluster.FlattenCluster(c.right, values);
        }

        return values;
    }

    static ComputeMeanValueForFlattenCluster(c) {
        let bbox2D = new THREE.Box3();
        let bbox3D = new THREE.Box3();

        c.forEach(b => {
            bbox2D.expandByPoint(b.currentPosProjected);
            bbox3D.expandByPoint(b.currentPos3D);
        });

        return {
            center2D: bbox2D.getCenter(new THREE.Vector3()),
            center3D: bbox3D.getCenter(new THREE.Vector3())
        };
    }

    constructor(clusterfck, distanceFunc, threshold = undefined) {
        this._clusterfck = clusterfck;
        this.setDistanceFuncAndThreshold(distanceFunc, threshold);
    }

    setDistanceFuncAndThreshold(distanceFunc, threshold = undefined) {
        this._distanceFunc = distanceFunc;
        this._threshold = threshold;
    }

    setThreshold(threshold) {
        this._threshold = threshold;
    }

    createClusters(clusterItems) {
        let clusters = this._clusterfck.hcluster(clusterItems, this._distanceFunc, this._clusterfck.AVERAGE_LINKAGE, this._threshold);
        //console.log(clusters);

        return clusters;
    }
}
